var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDastanLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32.0773,
    viewBox: "0 0 32 32.0773",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.93145 4.93114C6.73348 3.12933 9.66552 3.12933 11.467 4.93114L12.4682 5.93281L13.4694 6.93389L15.9995 9.4637L17.3316 10.7957L20.5326 13.9957L23.0627 11.4659L19.8623 8.26587L18.5296 6.93389L15.9995 4.40407L14.9983 3.4024L13.9971 2.40133C10.7949 -0.800442 5.60348 -0.800442 2.40132 2.40133C0.800241 4.00221 7.45058e-08 6.10035 7.45058e-08 8.1985C7.45058e-08 10.2966 0.800241 12.3948 2.40132 13.9951L4.93145 11.4659C3.12941 9.66404 3.12941 6.73236 4.93145 4.93114Z",
    fill: "#00426C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.0683 27.0733C25.2662 28.8751 22.3348 28.8751 20.5328 27.0733L18.5298 25.0706L16.0002 22.5407L15.9996 22.5413L14.9984 21.5397L11.4671 18.0088L8.9376 20.5386L12.4689 24.0695L13.4701 25.0706L15.9996 27.6004L17.3324 28.9324L18.0026 29.6025C21.2048 32.8043 26.3962 32.8043 29.5984 29.6025C32.8005 26.4013 32.8005 21.2105 29.5984 18.0088L27.0683 20.5386C28.8703 22.3398 28.8703 25.2715 27.0683 27.0733Z",
    fill: "#00426C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.4664 27.147C9.66499 28.9488 6.73307 28.9488 4.9311 27.147C3.12914 25.3452 3.12914 22.4135 4.9311 20.6122L5.86489 19.6785V19.6779L6.93402 18.6095L9.46345 16.0802V16.0796L10.7288 14.815L13.9964 11.5476L11.4664 9.01778L6.93342 13.5504L4.40399 16.0796L3.33486 17.1487L2.40108 18.0824C-0.80036 21.2842 -0.80036 26.475 2.40108 29.6762C4.0021 31.2771 6.10042 32.0773 8.19873 32.0773C10.2971 32.0773 12.3954 31.2771 13.9964 29.6762L11.4664 27.147Z",
    fill: "#00A8AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.5272 4.93088C22.3292 3.12905 25.2605 3.12905 27.0625 4.93088C28.8645 6.73212 28.8645 9.66382 27.0625 11.4656L25.0596 13.4684L22.5296 15.9982L21.5201 17.0077L17.9972 20.5303L20.5272 23.0595L25.0596 18.5275L27.5896 15.9977L28.9134 14.674L29.5925 13.9949C32.7946 10.7937 32.7946 5.60284 29.5925 2.40105C27.9915 0.80015 25.8932 0 23.7949 0C21.6966 0 19.5982 0.80015 17.9972 2.40105L20.5272 4.93088Z",
    fill: "#00A8AD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.0034 13.4999L13.4734 16.0291L16.0034 18.559L18.5328 16.0291L16.0034 13.4999Z",
    fill: "#00A8AD"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDastanLogo);
export default __webpack_public_path__ + "static/media/dastan-logo.e473a8a9c7ca5ffe7d7bf2e20cb466ed.svg";
export { ForwardRef as ReactComponent };